module.exports = __webpack_public_path__ + "img/checked.ecb20acb.svg";